module.exports = __webpack_public_path__ + "media/images/new/partner-logos-cb62b11ae015f19b787dc871be5cee31.png";